import { render } from "./Sidebar.vue?vue&type=template&id=05b10a38&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=05b10a38&lang=scss"
import "./Sidebar.vue?vue&type=style&index=1&id=05b10a38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05b10a38"

export default script